import React, { ReactNode } from 'react';
import styles from '../../organisation.module.scss';
import OrganizationModal from 'shared/components/OrganizationModal';
import { CompanySetupEnum } from 'enums/CompanySetupEnums';
import TabsComponent from 'shared/components/TabsComponent';
export interface Tab {
  key: string;
  label: string;
  children: ReactNode;
}
interface OrganizationModalContentProps {
  isOrgVisible: boolean;
  handleCancelModal: () => void;
  tabs: Tab[];
  activeTab: string;
}

export const OrganizationModalContent: React.FC<
  OrganizationModalContentProps
> = ({ isOrgVisible, handleCancelModal, tabs, activeTab }) => {
  return (
    <OrganizationModal
      visible={isOrgVisible}
      onClose={handleCancelModal}
      title={CompanySetupEnum.NewOrganizationTitle}
      isExtraSpace>
      <div className={styles.subtitle}>
        {CompanySetupEnum.NewOrganizationSubtitle}
      </div>
      <div className={styles.textDetail}>
        {CompanySetupEnum.NewOrganizationTextDetail}
      </div>
      <div className={styles.tabContainer}>
        <TabsComponent tabs={tabs} activeTab={activeTab} />
      </div>
    </OrganizationModal>
  );
};
